import http from 'hub-http/clients/apiClient';
const API_BASE = 'messages/v2/inbox';
const HELPDESK_BASE = `cv-forms-integration-legacy/v1/connected-crm-object`;
export const fetchInboxes = () => http.get(`${API_BASE}`);
export const fetchInboxById = id => http.get(`${API_BASE}/${id}`);
export const fetchInboxByGuid = guid => http.get(`${HELPDESK_BASE}/object-type-id/FORM_SUBMISSION/connected-object-source-id/${guid}/unhydrated-with-inbox`);